import React, { useState, useEffect } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { makeStyles } from "@material-ui/core/styles";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import axios from "axios";
import branchStyle from "assets/jss/material-dashboard-react/views/goldRatesStyle.js";
import ToastModal from "views/components/ToastModal";

const useStyles = makeStyles(branchStyle);

const AssignStartOtp = () => {
  const classes = useStyles();
  const params = useParams();
  const navigate = useNavigate();

  const [userId, setUserId] = useState("");
  const [mounted, setMounted] = useState(false);
  const [isErrorMode, setErrorMode] = useState(false);
  const [isOtpMode, setIsOtpMode] = useState(false);
  const [isValidateMode, setIsValidateMode] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [otpValidation, setOtpValidation] = useState("");

  const [loanApplicationId, setLoanApplicationId] = useState(10);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');


  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  // //public / v1 / user / exists ? username = ' + phoneNumber
  // const mobileNumberotp = async (phoneNumber) => {
  //     const data = {
  //         loanApplicationId: loanApplicationId,

  //     }
  //     const header = {
  //         headers: {
  //             Authorization: 'Bearer ' + localStorage.getItem('token'),
  //         },
  //     };
  //     //console.log(data);
  //     axios.put('loan-service/public/v1/user/exists', data, header)
  //         .then((res) => {
  //             //console.log(response.data);
  //             if (res?.data?.error_code && res?.data?.error_code === 403) {
  //                 return;
  //             }
  //             else {
  //        

  //             }
  //         });

  //     // navigation.navigate(LOANREJECT_SCREEN);
  //     // alert("Application Reject")

  // };
  const resendcode = async () => {
    const data = {
      loanApplicationId: loanApplicationId,
    };
    const header = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    axios
      .put("loan-service/v1/agent/loan/application/startTask", data, header)
      .then((res) => {
        if (res?.data?.error_code && res?.data?.error_code === 403) {
          toastUpdate("Error", res?.data?.user_description, true);
          return;
        } else {
          toastUpdate("Information","Please check for New OTP on Mobile", true);
        }
      });

    // navigation.navigate(LOANREJECT_SCREEN);
    // alert("Application Reject")
  };
  const handlecreateapplicantSubmit = async () => {
    const data = {
      loanApplicationId: loanApplicationId,
      otp: otpValidation,
    };
    const header = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    // this.setState({ callInProgress: true });
    axios
      .post("loan-service/v1/agent/loan/application/validateOtp", data, header)
      .then((res) => {
        //this.setState({ callInProgress: false });
        if (res?.data?.error_code && res?.data?.error_code === 403) {
          toastUpdate("Error", res?.data?.user_description, true);
          setErrorMode(true);
          return;
        } else if (res?.data?.error_code) {
          toastUpdate("Error", res?.data?.user_description, true);
          return;
        } else {
          toastUpdate("Information","OTP successfully", true);
          setErrorMode(false);
          //props.navigate(`/admin/ornament`);
          //  closeModal();
        }
      });
  };

  // const handlecancel = () => {
  //     closeModal();
  // }
  const validatecode = () => {
    const data = {
      source: mobileNumber?.trim(),
      otp: otpValidation,
    };
    // const header = {
    //     headers: {
    //         Authorization: 'Bearer ' + localStorage.getItem('token'),
    //     },
    // };

    axios
      .post("/loan-service/public/v1/verfication/verify", data)
      .then((res) => {
        //this.setState({ callInProgress: false });
        if (res?.data?.error_code && res?.data?.error_code === 403) {
          toastUpdate("Error", res?.data?.user_description, true);
          // setErrorMode(true);
          return;
        } else {
          toastUpdate("Information","OTP is successfully verified", true);
          setIsValidateMode(true);
          // CreateLoanApplication();
          //props.navigate(`/admin/ornament`);
        }
      });
  };
  // const CreateLoanApplication = () => {
  //     const data = {
  //         loanAmount: "Less Than 1 Lakh",
  //         name: "Avinash Gupta",
  //         email: "avinashg490@gmail.com",
  //         mobileNumber: "9340839368",
  //         appointment: "2021-04-02 11:45",
  //         address: "Flat 704, new ashok Nagar ",
  //         pincode: "110020",
  //         city: "Delhi",
  //         state: "Delhi",
  //         country: "India"

  //     };
  //     const header = {
  //         headers: {
  //             Authorization: 'Bearer ' + localStorage.getItem('token'),
  //         },
  //     };

  //     axios
  //         .post('/loan-service/v1/customer/loan/application/submit', data, header)
  //         .then((res) => {
  //             //this.setState({ callInProgress: false });
  //             if (res?.data?.errorCode && res?.data?.errorCode === 403) {
  //           
  //                 // setErrorMode(true);
  //                 return;
  //             }
  //             else {
  //           
  //                 setIsValidateMode(true);
  //                 props.navigate(`/admin/ornament`);

  //             }
  //         });

  // };
  const sentOtp = () => {
    const data = {
      source: mobileNumber?.trim(),
      type: "MOBILE",
    };
    // const header = {
    //     headers: {
    //         Authorization: 'Bearer ' + localStorage.getItem('token'),
    //     },
    // };

    axios
      .post("/loan-service/public/v1/verfication/sendOtp", data)
      .then((res) => {
        //this.setState({ callInProgress: false });
        if (res?.data?.error_code && res?.data?.error_code === 403) {
          toastUpdate("Error", res?.data?.user_description, true);
          setIsOtpMode(false);
          return;
        } else {
          toastUpdate("Information","Please check your Mobile for OTP code", true);
          setIsOtpMode(true);
          //props.navigate(`/admin/ornament`);
        }
      });
  };

  return (
    <div>
      <GridContainer style={{ flexDirection: "row" }}>
        <GridItem xs={4} sm={4} md={4} lg={4}>
          <div>
            <h3 style={{ fontWeight: 500 }}>Create Account</h3>
          </div>
        </GridItem>
      </GridContainer>
      <hr />
      <GridContainer style={{ marginTop: 40 }}>
        <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer
              style={{
                margin: 10,
                border: "1px solid #cccccc",
                textAlign: "start",
              }}
            >
              <GridItem xs={4} sm={4} md={4} lg={4}>
                <CustomInput
                  labelText="Mobile Number*"
                  id="number"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    value: mobileNumber?.trim(),
                    onChange: (e) => setMobileNumber(e.target.value),
                  }}
                />
              </GridItem>
              <GridItem
                xs={8}
                sm={8}
                md={8}
                lg={8}
                style={{ marginTop: 27, textAlign: "start" }}
              >
                <Button
                  size="small"
                  className="bg-gradient-theme-left border-0"
                  color="info"
                  onClick={() => sentOtp()}
                >
                  Send OTP
                </Button>
              </GridItem>
              {isOtpMode && (
                <>
                  <GridItem xs={4} sm={4} md={4} lg={4}>
                    <CustomInput
                      labelText="OTP Code*"
                      id="otp"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: otpValidation,
                        onChange: (e) => setOtpValidation(e.target.value),
                      }}
                    />
                  </GridItem>
                  <GridItem
                    xs={3}
                    sm={3}
                    md={3}
                    lg={3}
                    style={{ marginTop: 27 }}
                  >
                    <Button
                      size="small"
                      className="bg-gradient-theme-left border-0"
                      color="info"
                      onClick={() => validatecode()}
                    >
                      Validate
                    </Button>
                  </GridItem>
                  <GridItem
                    xs={3}
                    sm={3}
                    md={3}
                    lg={3}
                    style={{ marginTop: 27 }}
                  >
                    <Button
                      size="small"
                      className="bg-gradient-theme-left border-0"
                      color="info"
                      onClick={() => resendcode()}
                    >
                      Resend Code
                    </Button>
                  </GridItem>
                  {isErrorMode && (
                    <GridItem xs={2} sm={2} md={2} lg={2}>
                      <p> Please provide the correct OTP code</p>
                    </GridItem>
                  )}
                </>
              )}
            </GridContainer>
        </GridItem>
        {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      </GridContainer>
      {/* <GridContainer style={{ flexDirection: 'row' }}>
                <GridItem xs={12} sm={12} md={4}>

                </GridItem>
                <GridItem
                    xs={12}
                    sm={12}
                    md={8}
                    style={{ textAlignLast: 'right', alignSelf: 'center' }}
                >
                    <Button
                        style={{ margin: '5px' }}
                        size="small"
                        color="info"
                        className="bg-gradient-theme-left border-0"
                        onClick={() => handlecreateapplicantSubmit()}
                    >
                        Save
                    </Button>
                    <Button
                        style={{ margin: '5px' }}
                        size="small"
                        className="bg-gradient-theme-left border-0"
                        onClick={() => handlecancel()}
                    >
                        Cancel
                    </Button>
                </GridItem>
            </GridContainer> */}
    </div>
  );
};

AssignStartOtp.propTypes = {
  classes: PropTypes.object,
  // closeModal: PropTypes.func,
};

export default AssignStartOtp;
